import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.poll = this.poll.bind(this)
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (!this.hasUrlValue || this.timer) return
    if (!this.activeImportPresent()) return

    this.timer = window.setInterval(this.poll, this.intervalValue)
  }

  stopPolling() {
    if (!this.timer) return

    window.clearInterval(this.timer)
    this.timer = null
  }

  async poll() {
    if (!this.activeImportPresent()) {
      this.stopPolling()
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "text/html"
        },
        credentials: "same-origin"
      })

      if (!response.ok) return

      const html = await response.text()
      const doc = new DOMParser().parseFromString(html, "text/html")
      const replacement = doc.getElementById("data_imports_panel")
      if (!replacement) return

      this.element.outerHTML = replacement.outerHTML
    } catch (_error) {
      // Keep the page usable even if polling fails.
    }
  }

  activeImportPresent() {
    return this.element.querySelector('[data-import-active="true"]') !== null
  }
}
